export const getAllSections = (state) =>
  state.sections.get("allIds").map((id) => getSectionById(state, id));

export const getSectionById = (state, id) => {
  const section = state.sections.getIn(["byId", id]);

  if (!section) {
    throw new Error(`Unable to find section with id ${id}`);
  }

  return section;
};

export const getSectionCategories = (section) => section.get("categories");
